import * as THREE from "three";

export function getSize(obj) {
    const boundingBox = new THREE.Box3().setFromObject(obj)

    const xSize = boundingBox.max.x - boundingBox.min.x
    const ySize = boundingBox.max.y - boundingBox.min.y
    const zSize = boundingBox.max.z - boundingBox.min.z
    return {
        x: xSize,
        y: ySize,
        z: zSize
    }
}

export function scrollSpeed (controls) {

    let lastPos, newPos, delta

    function clear() {
        lastPos = null;
        delta = 0;
    }

    clear();

    return function () {
        newPos = controls.getAzimuthalAngle();
        if (lastPos != null) {
            delta = newPos - lastPos;
            // Handle wrap-around from PI to -PI
            if (delta > Math.PI) delta -= Math.PI * 2;
            if (delta < -Math.PI) delta += Math.PI * 2;
        }

        lastPos = newPos;
        return delta;

    };
}

export function rotateIfObject(azimuthalAngle, rotation, forw, point, light) {
    let lookLen = 0.40
    if (azimuthalAngle > point && azimuthalAngle <= point + lookLen / 2) {
        let angle = Math.PI / 2 * ((azimuthalAngle - point) / (lookLen / 2));
        light.visible = true
        rotation = rotation + (forw ? angle : -angle)
    } else if (azimuthalAngle > point + lookLen / 2 && azimuthalAngle < point + lookLen) {
        let angle = Math.PI / 2 - Math.PI / 2 * ((azimuthalAngle - (point + lookLen / 2)) / (lookLen / 2));
        rotation = rotation + (forw ? angle : -angle)
        light.visible = true
    } else {
        light.visible = false
    }
    return rotation;
}

export function createFloatingTextTexture(text, color = '#39ff14') {
    const canvas = document.createElement('canvas');
    canvas.width = 512;
    canvas.height = 128;
    const ctx = canvas.getContext('2d');
    ctx.fillStyle = 'rgba(0,0,0,0)';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.font = 'bold 60px "Orbitron", sans-serif';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    // Cartoon black outline
    ctx.lineWidth = 6;
    ctx.strokeStyle = '#000000';
    ctx.lineJoin = 'round';
    ctx.strokeText(text, canvas.width / 2, canvas.height / 2);
    ctx.fillStyle = color;
    ctx.fillText(text, canvas.width / 2, canvas.height / 2);
    return new THREE.CanvasTexture(canvas);
}
